import _ from 'lodash';
import ShippingCostTable from 'src/entities/basic-types/ShippingCostTable';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';

export const getShippingCostTable = (state: any): SingleEntityState<ShippingCostTable> => {
    const shippingCostTable = state.shippingCostTable;
    if (_.isEmpty(shippingCostTable)) return singleEntityDefaultState<ShippingCostTable>();

    return {
        isFetching: shippingCostTable.isFetching,
        error: shippingCostTable.error,
        content: shippingCostTable.content ? new ShippingCostTable(shippingCostTable.content) : undefined,
    };
};
